import { LayoutGrid } from "lucide-react";
import { Carte, COL, Indisponible, Ligne, Valeur, dateFr, isErreur } from "./shared";

const culture = (c) => c.libelle;

// Mobile : une fiche par îlot ; ordinateur : un tableau.
export default function IlotsCard({ data, desktop, className = "" }) {
  const erreur = isErreur(data);
  return (
    <Carte titre={`Îlots${!erreur && data.length && data[0].ilot_id ? ` (${data.length})` : ""}`} numero="3" icon={LayoutGrid}
      className={className} testId="fiche-ilots">
      {erreur ? <Indisponible /> : desktop ? (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-xs text-gray-500 border-b" style={{ borderColor: COL.line }}>
                {["Îlot", "Surface", "Culture", "Variété", "Plantation", "Stade BBCH", "Précédent", "Objectif"].map((h) => (
                  <th key={h} className="py-2 pr-3 font-medium">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((i) => (
                <tr key={i.ilot_id || "parcelle"} className="border-b last:border-b-0 align-top" style={{ borderColor: COL.line }}>
                  <td className="py-2 pr-3 font-semibold">{i.nom}</td>
                  {[["surface"], ["culture", culture], ["variete"], ["date_plantation", dateFr], ["stade_bbch"], ["precedent"],
                    ["objectif_rendement"]].map(([k, f]) => (
                    <td key={k} className="py-2 pr-3"><Valeur v={i[k]} format={f} align="left" /></td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="space-y-3">
          {data.map((i) => (
            <div key={i.ilot_id || "parcelle"} className="rounded-xl border px-3 py-1" style={{ borderColor: COL.line }}>
              <div className="text-sm font-bold pt-2" style={{ color: COL.text }}>{i.nom}</div>
              <Ligne label="Surface" v={i.surface} />
              <Ligne label="Culture" v={i.culture} format={culture} />
              <Ligne label="Variété" v={i.variete} />
              <Ligne label="Plantation" v={i.date_plantation} format={dateFr} />
              <Ligne label="Stade BBCH" v={i.stade_bbch} />
              <Ligne label="Précédent" v={i.precedent} />
              <Ligne label="Objectif de rendement" v={i.objectif_rendement} />
            </div>
          ))}
        </div>
      )}
    </Carte>
  );
}
